<template>
  <div>
    <div class="d-flex toolbar justify-content-between mb-4">
      <h4 class="text-color-4">{{ $t("settings.account.label") }}</h4>
    </div>
    <div v-if="loading">
      <Spinner size="sm" />
    </div>
    <div v-else
         id="account-form">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="handleFormSubmit">

          <div class="row">
            <div class="col-3">
              <p class="text-nowrap">ชื่อร้าน</p>
            </div>
            <div class="col-9">
              <TextBox type="text"
                       id="company-name"
                       rules="required"
                       v-model="accountSettingsForm.compName" />
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <p class="text-nowrap">{{ $t('general.phone') }}</p>
            </div>
            <div class="col-9">
              <PhoneNumber id="account-phone-no"
                           v-model="accountSettingsForm.phoneNo"
                           rules="required" />
            </div>
          </div>





          <SmartAddress :label="$t('general.address.address')"
                        placeholder="Address"
                        id="account-address"
                        rules="required"
                        :horizontal="true"
                        :value="{
        addr: accountSettingsForm.addr,
        dist: accountSettingsForm.dist,
        subDist: accountSettingsForm.subDist,
        prov: accountSettingsForm.prov,
        zip: accountSettingsForm.zip,
      }"
                        @change="handleAddressChange" />

          <Button type="submit"
                  variant="primary"
                  custom_class="btn-block mr-4"
                  :disabled="invalid"
                  :loading="formLoading">{{ $t("general.update") }}</Button>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import Button from "@/components/core/Button";
import NumberField from "@/components/core/NumberField";
import Card from "@/components/core/Card";
import TextBox from "@/components/core/TextBox";
import PhoneNumber from "@/components/derived/PhoneNumber";
import VatField from "@/components/derived/VatField";
import SmartAddress from "@/components/derived/SmartAddress";
import Spinner from "@/components/core/Spinner";

export default {
  name: "SellerSettingsAccount",
  components: {
    Card,
    TextBox,
    PhoneNumber,
    Spinner,
    Button,
    SmartAddress,
    NumberField,
    VatField,
  },

  data() {
    return {
      loading: false,
      formLoading: false,
      accountSettingsForm: {
        compName: null,
        phoneNo: null,
        addr: null,
        dist: null,
        subDist: null,
        prov: null,
        zip: null
      },
    };
  },

  async created() {
    await this.fetchData();
  },

  methods: {

    handleAddressChange({ addr, dist, subDist, prov, zip, phoneNo, name }) {
      this.accountSettingsForm = {
        ...this.accountSettingsForm,
        addr,
        dist,
        subDist,
        prov,
        zip,
        phoneNo: phoneNo ? phoneNo : this.accountSettingsForm.phoneNo,
        compName: name ? name : this.accountSettingsForm.compName
      }
    },

    async fetchData() {
      this.loading = true;
      const { status, data } = await this.$store.dispatch("settings/fetchSetting", { type: "account" });
      if (status) this.accountSettingsForm = data
      this.loading = false;
    },

    async handleFormSubmit() {
      this.formLoading = true;
      const { status } = await this.$store.dispatch("settings/updateSetting", {
        type: "account",
        data: {
          phoneNo: this.accountSettingsForm.phoneNo,
          compName: this.accountSettingsForm.compName,
          addr: this.accountSettingsForm.addr,
          dist: this.accountSettingsForm.dist,
          subDist: this.accountSettingsForm.subDist,
          prov: this.accountSettingsForm.prov,
          zip: this.accountSettingsForm.zip
        }
      });
      this.formLoading = false;
    },
  },
};
</script>

<style lang="scss"
       scoped>
      .setting__header {
        font-weight: bold;
        font-size: 18px;
      }

      .setting__description {
        font-weight: thin;
        font-size: 13px;
      }

      .setting {
        &.--inline {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        &.--table {
          .setting__text {
            margin-bottom: 20px;
          }
        }

        margin-bottom: 30px;
      }

      .settings-wrapper {
        margin-top: 24px;
      }

      .setting-status-tag {
        text-transform: uppercase;

        font-weight: bold;
        font-size: 12px;
        padding: 5px 10px;
        border-radius: 2px;
        text-align: center;
        width: 68px;
        height: 29px;

        &.--warning {
          background-color: #ffc107;
          color: black;
        }

        &.--success {
          background-color: #28a745;
          color: white;
        }

        &.--danger {
          background-color: #dc3545;
          color: white;
        }

        &.--info {
          background-color: #007bff;
          color: white;
        }
      }
    </style>